import { render, staticRenderFns } from "./HoldingShipment.vue?vue&type=template&id=968d4ad0&"
import script from "./HoldingShipment.vue?vue&type=script&lang=js&"
export * from "./HoldingShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports